module.exports = __webpack_public_path__ + "static/media/lock.c6edd13a.svg";